import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const PURCHASE_SECTION_ID = 'seccion-compra'
const SCROLL_OFFSET = 20

/**
 * Desplaza suavemente hasta el inicio exacto de la sección principal de compra.
 * La posición se calcula en el momento del clic (nunca se guarda al cargar).
 * Devuelve false si la sección todavía no está montada.
 */
export function scrollToPurchaseSection(): boolean {
  const destino = document.getElementById(PURCHASE_SECTION_ID)
  if (!destino) return false

  const posicion =
    destino.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET
  window.scrollTo({
    top: posicion,
    behavior: 'smooth',
  })

  // Corrección única por si una imagen tardía cambia la altura del documento.
  window.setTimeout(() => {
    const destinoFinal = document.getElementById(PURCHASE_SECTION_ID)
    if (!destinoFinal) return
    const posicionFinal =
      destinoFinal.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET
    window.scrollTo({
      top: posicionFinal,
      behavior: 'smooth',
    })
  }, 500)

  return true
}
